module.exports = __webpack_public_path__ + "static/media/Map5.13c403d8.jpg";